


//import {typesSojourn} from '../types/sojournTypes'
import {typesCruisedet} from './svtypes/cruisedetTypes'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
const HBD_URL = 'http://photos.hotelbeds.com/giata/'
  
/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/essearch/svuila
//POST http://localhost:8080/essearch/svuila
rq
{
  "query": {
    "match": {
      "sojourn_name": {
        "query": "mancreek",
        "operator": "and"
      }
    }
  }
}



*/
let initStore = {
    loading: false,
    error: false,
    fgtree :{
        "10": {
            "facilityGroupCodeName": "Location",
            "facilityGroupCode": 10,
            "facilities": [
                {
                    "id": 12,
                    "code": 100,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Suites"
                },
                {
                    "id": 30,
                    "code": 110,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Apartments"
                },
                {
                    "id": 53,
                    "code": 124,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Disability-friendly rooms"
                },
                {
                    "id": 109,
                    "code": 20,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Year of construction"
                },
                {
                    "id": 224,
                    "code": 30,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Year of most recent renovation"
                },
                {
                    "id": 315,
                    "code": 40,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Annexe (s)"
                },
                {
                    "id": 358,
                    "code": 50,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Number of floors (main building)"
                },
                {
                    "id": 447,
                    "code": 60,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Number of floors (annexe)"
                },
                {
                    "id": 493,
                    "code": 70,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 20,
                    "description": "Total number of rooms"
                },
                {
                    "id": 533,
                    "code": 80,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Single rooms"
                },
                {
                    "id": 576,
                    "code": 90,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Double rooms"
                },
                {
                    "id": 589,
                    "code": 95,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Junior suites"
                }
            ]
        }
    },
     //sjjul3 commented
   // my_data: [],
    svr_cruise_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    excursions:[],
   
    //sjjul3 start
    my_esqueryText : "mexco",
    svcli_esquery_data : {
       
       
       
        escountryOrg:"LAX",
        escountryDst:"A",
        my_orgqueryText: "xx",
        my_dstqueryText: "yy",
        STARTDATE:"2025-11-25",
        ENDDATE: "2025-11-27",
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "Asia/Kolkata",


        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esquerySpecials:"J",
        esqueryTripType:"roundtrip",
        esqueryPortcall : "LAX",
        esqueryShip : "AQ",
        esqueryDur : "D1",
        svpageSize:5
         /*arilines end */

    },
    hasMore:true,
    ctotal:3,
    my_scr_id:"AAluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR",
    my_data: [{
        "code": "MI",
        "departurePortCode": "SEA",
        "departurePortName": "Seattle, WA",
        "dur": 7,
        "duration": null,
        "exTrip": {
            "arrivalDate": "2026-05-14T00:00:00.000Z",
            "arrivalDayOfWeek": "Thu",
            "arrivalDayOfWeekFull": null,
            "arrivalMmmDYyyy": null,
            "arrivalMmmDdYyyy": null,
            "departureDate": "2026-05-07T00:00:00.000Z",
            "departureDayOfWeek": "Thu",
            "departureDayOfWeekFull": null,
            "departureMmmDYyyy": null,
            "departureMmmDdYyyy": null,
            "embarkPortCode": "SEA",
            "exSchedule": null,
            "fromPrice": 0,
            "fromPriceCurrency": "USD",
            "leadMetaCode": "IS",
            "taxesAndFees": 0
        },
        "hasExtraValue": true,
        "id": "GA2_SEA_SP_6_Mon",
        "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
        "imageRandomizationInfo": null,
        "imageSquare": null,
        "imageUrl": null,
        "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
        "itineraryTitleFormatted": null,
        "itineraryURL": null,
        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
        "portsToDisplay": null,
        "regionCode": "GL",
        "regionName": null,
        "roundtrip": true,
        "sailings": null,
        "shipCode": "MI",
        "shipName": null,
        "specialScoops": null,
        "stateroomMetaInformation": null,
        "taxesAndFeesRange": null
    }],
    svr_soj_images : []
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
       
        case 'GET_CRUISEDET_SUCCESS':
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            if(action.payload.my_images){
                januState = {...state, loading: false, my_data: action.payload.my_data, svr_soj_detail_images_ob: action.payload.my_images}
            }else{
                januState = {...state, loading: false, my_data: action.payload.my_data}
            }
             
            return januState
      /*
        case "GET_SOJ_PROD_AVL_HOTEL_SUCCESS":
                console.log("svoct17 SVESSearchRedicerreduce %%%%%%%%evsearcg  success*****************");
                console.log(action.payload);
                console.log("svoct17 end  SVESSearchRedicerreduce %%%%%%%%evsearcg  success*****************");
                let sj_scr_id=action.payload.my_scr_id ? action.payload.my_scr_id  : ''
                let fgtree = action.payload.fgtree ? action.payload.fgtree : {}
                let n_total = action.payload.my_data ? action.payload.my_data.length : 0
                let ps = state.ctotal
                let onddata_ar = action.payload.my_data.slice(0,1)

                let images =onddata_ar[0].hotel.images

               
                let im = null
                let ar_hib_images = []
                for(let i=0; i < images.length; i++){
                    im = HBD_URL + images[i].path 
                    ar_hib_images.push(im)

                }
                let svr_soj_detail_images_ob_tp = {
                    "images":ar_hib_images ? ar_hib_images.slice(0,9):[],
                    "gallery":ar_hib_images ? ar_hib_images.slice(0,6):[],
                    "arcade":ar_hib_images ? ar_hib_images.slice(0,2):[],
                    "face":ar_hib_images ? ar_hib_images.slice(0,1):[],
                
                }
                let sj_total = ps + n_total
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                if(action.payload.sv_esquery_data){
                   // januState = {...state, loading: false,  ctotal:sj_total,  my_scr_id:sj_scr_id, my_data: action.payload.my_data, svr_soj_images: action.payload.my_images, sv_esquery_data: action.payload.sv_esquery_data}
                   januState = {...state,error: false, loading: false,  ctotal:sj_total, fgtree:fgtree,svr_soj_detail_images_ob:svr_soj_detail_images_ob_tp, my_scr_id:sj_scr_id, my_data: onddata_ar, svr_soj_images: action.payload.my_images, sv_esquery_data: action.payload.sv_esquery_data}
                
                }else{
                    januState = {...state, error: false,loading: false,  ctotal:sj_total,  fgtree:fgtree, svr_soj_detail_images_ob:svr_soj_detail_images_ob_tp, my_scr_id:sj_scr_id, my_data: onddata_ar, svr_soj_images: action.payload.my_images}
                   // januState = {...state, loading: false,  ctotal:sj_total, my_scr_id:sj_scr_id, my_data: action.payload.my_data, svr_soj_images: action.payload.my_images}
                
                }
                return januState
        case "GET_SOJ_PROD_AVL_HOTEL_SERVER_ERROR":
            console.log("error GET_SOJ_PROD_AVL_HOTEL_SERVER_ERROR or other ")
            return {...state,loading: false, hasMore:false, error: true}
        */ 
        case 'GET_CRUISEDET_BEGIN':
            console.log("loading")
            return {...state, loading: true}
        case 'GET_CRUISEDET_ERROR':
            console.log("error")
            return {...state, error: true}
        default:
            return state
    }
}